var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSolidFull1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 7.8C9.65755 7.8 11 6.4575 11 4.8C11 3.1425 9.65755 1.8 8.00005 1.8C6.34255 1.8 5.00005 3.1425 5.00005 4.8C5.00005 6.4575 6.34255 7.8 8.00005 7.8ZM7.25755 9.2C4.79505 9.2 2.80005 11.195 2.80005 13.6575C2.80005 14.0675 3.13255 14.4 3.54255 14.4H12.4575C12.8675 14.4 13.2 14.0675 13.2 13.6575C13.2 11.195 11.205 9.2 8.74255 9.2H7.25755Z",
    fill: "#3F3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolidFull1);
export default __webpack_public_path__ + "static/media/user-solid-full 1.50c874fe0efb456d0dbcadf8f1e0f28d.svg";
export { ForwardRef as ReactComponent };